import { React, useEffect, useState, useRef } from "react";

// Modules
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// App
import {
  serverUrl,
  presenterTaxonomies,
  userProfilePictureEnabled,
  sitaEnabled,
  referenceEnabled,
  client,
} from "../../config";
import { patchNode } from "../../core/postNode";
import { getOnlineNode } from "../../core/getNode";
import PageHeader from "../../partials/pageHeader";
import { alertMessages } from "../../partials/alertMessages";
import AlertModal from "../../partials/alertModal";
import Error from "../../partials/error";
import AccountSkeletonScreen from "./skeleton-screens/accountSkeletonScreen";
import { editProfileEnabled } from "../../config";

// UI components
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  CircularProgress,
  Typography,
} from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";
import CategorySelector from "../../partials/categorySelector";
import { Link } from "react-router-dom";
import UserImage from "../../partials/userImage";
import Creator from "../../partials/creator";

export default function EditProfile(props) {
  const [isLoading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [_user, _setUser] = useState("");

  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [field_job_title, setField_job_title] = useState("");
  const [field_url, setField_url] = useState("");
  const [field_address, setField_address] = useState("");
  const [field_email_template, setField_email_template] = useState("");
  const [field_sita, setField_sita] = useState("");
  const [field_reference, setField_reference] = useState("");
  const [field_cost_centre, setField_cost_centre] = useState("");
  const [field_region, setField_region] = useState("");

  const [category_email_template, setCategory_email_template] = useState(null);
  const [category_sita, setCategory_sita] = useState(null);
  const [category_reference, setCategory_reference] = useState(null);
  const [category_region, setCategory_region] = useState(null);

  const [modalVisible, setModalVisible] = useState(false);

  const [isError, setError] = useState(false);
  const [errorStatus, setErrorStatus] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const [alertType, setAlertType] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  const [alertBody, setAlertBody] = useState("");
  const [alertConfirmButton, setAlertConfirmButton] = useState(false);

  const [postModalVisible, setPostModalVisible] = useState(false);

  const user = useSelector((state) => state).authReducer.user;
  const navigate = useNavigate();

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    if (_user) {
      getContent();
    }
    // eslint-disable-next-line
  }, [_user]);

  useEffect(() => {
    if (presenterTaxonomies) {
      if (
        category_email_template !== null &&
        category_sita !== null &&
        category_reference !== null &&
        category_region !== null
      ) {
        if (sitaEnabled) {
          if (category_sita !== null) {
            getAccount();
          }
        } else {
          getAccount();
        }

        getAccount();
      }
    } else {
      getAccount();
    }
    // eslint-disable-next-line
  }, [category_email_template, category_sita, category_reference, category_region]);

  const backToAccount = useRef(null);
  const containerRef = useRef(null);

  const getAccount = () => {
    if (typeof user.current_user === "undefined") {
      navigate("/");
    } else {
      let path = `api/v2/users?uid=${user.current_user.uid}`;

      if (client === "equans") {
        path = `custom_user/${user.current_user.uid}`;
      }

      getOnlineNode(path)
        .then((response) => {
          if (response.data.rows[0]) {
            _setUser(response.data.rows[0]);
          } else {
            setError(true);
            setLoading(false);
          }
        })
        .catch((_error) => {
          setError(true);
          setErrorStatus(_error.response.status);
          setErrorMessage(_error.response.statusText);
          setLoading(false);
        });
    }
  };

  const getContent = () => {
    if (_user) {
      let sita_code;
      let reference_code;

      if (sitaEnabled) {
        sita_code = category_sita?.find((el) => el.value === _user.field_sita);
      }

      if (referenceEnabled) {
        reference_code = category_reference?.find(
          (el) => el.value === _user.field_reference
        );
      }

      const email_template = category_email_template?.find(
        (el) => parseInt(el.value, 10) === parseInt(_user.field_email_template, 10)
      )?.value;

      setFirst_name(_user.field_first_name);
      setLast_name(_user.field_last_name);
      setPhone_number(_user.phone_number);
      setField_job_title(_user.field_job_title);
      setField_address(_user.field_address);
      setField_url(_user.field_url);

      if (presenterTaxonomies) {
        setField_email_template(
          email_template ?? category_email_template[0].value
        );
        setField_cost_centre(_user.field_cost_centre);

        if (sitaEnabled) {
          setField_sita(sita_code ? sita_code : category_sita[0].value);
        }

        if (referenceEnabled) {
          setField_reference(reference_code ? reference_code : category_reference[0]);
        }

        setField_region(_user.field_region);
      }
      setLoading(false);
    } else {
      setError(true);
      setLoading(false);
    }
  };

  const getCategories = () => {
    if (presenterTaxonomies) {
      getOnlineNode("api/categories?vid=email_templates,sita,reference,region")
        .then((response) => {
          let email_template = [
            {
              value: 0,
              label: "None",
            },
          ];

          let sita = [
            {
              value: 0,
              label: "None",
            },
          ];

          let reference = [
            {
              value: 0,
              label: "None",
            },
          ];

          let region = [
            {
              value: 0,
              label: "None",
            },
          ];

          response.data.forEach((item) => {
            if (item.has_view_permission === true) {
              if (item.vid === "email_templates")
                email_template.push({
                  value: item.tid,
                  label: item.title,
                });

              if (item.vid === "region")
                region.push({
                  value: item.tid,
                  label: item.title,
                });

              if (item.vid === "sita")
                sita.push({
                  value: item.tid,
                  label: item.title,
                });

              if (item.vid === "reference")
                reference.push({
                  value: item.tid,
                  label: item.title,
              })
            }
          });
          setCategory_email_template(email_template);
          setCategory_sita(sita);
          setCategory_reference(reference);
          setCategory_region(region);
        })
        .catch((_error) => {});
    }
  };

  const updateUser = () => {
    const uid = user.current_user.uid;
    setIsSubmitting(true);

    let data = {
      _links: {
        type: {
          href: serverUrl + "/rest/type/user/user",
        },
      },
      uid: {
        value: uid,
      },
      field_first_name: {
        value: first_name,
      },
      field_last_name: {
        value: last_name,
      },
      phone_number: {
        value: phone_number,
      },
      // pass: password,
      field_job_title: {
        value: field_job_title,
      },
      field_url: {
        value: field_url,
      },
      field_address: {
        value: field_address,
      },
      field_email_template:
        field_email_template.value !== 0
          ? [{ target_id: field_email_template }]
          : [],
      mail: [_user.mail],
    };

    if (field_email_template && parseInt(field_email_template.value) !== '0') {
      data.field_email_template = [{ target_id: field_email_template }];
    } else {
      data.field_email_template = [];
    }

    patchNode("user/" + uid, data, user.csrf_token)
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        // temp simple_oauth error
        if (
          error?.response?.status === 403 ||
          error?.response?.status === 401
        ) {
          backToAccount.current.click();
        } else {
          if (error?.response?.data?.message) {
            // setState({
            setIsSubmitting(false);
            setModalVisible(true);
            setAlertType("error");
            setAlertTitle(alertMessages.unkownError.title);
            setAlertBody(error.response.data.message);
            setAlertConfirmButton(true);
            // });
          } else {
            setIsSubmitting(false);
            setModalVisible(true);
            setAlertType("error");
            setAlertTitle(alertMessages.editProfileUpdateFailed.title);
            setAlertBody(alertMessages.editProfileUpdateFailed.message);
            setAlertConfirmButton(true);
          }
        }
      });
  };

  const errorAlerts = () => {
    return (
      <AlertModal
        showAlert={modalVisible}
        showAlertCallback={(condition) => setModalVisible(condition)}
        alertType={alertType}
        alertMessageTitle={alertTitle}
        alertMessageBody={alertBody}
        // cancelButton={alertCancelButton}
        confirmButton={alertConfirmButton}
        // cancelButtonLabel={cancelButtonLabel}
        // confirmButtonLabel={confirmButtonLabel}
      />
    );
  };

  const saveAlerts = () => {
    return (
      <AlertModal
        showAlert={postModalVisible}
        showAlertCallback={() => {
          let tempPostModalVisible = !postModalVisible;
          setPostModalVisible(tempPostModalVisible);
        }}
        alertType={"success"}
        alertMessageTitle={alertTitle}
        alertMessageBody={alertBody}
        cancelButton={false}
        confirmButton={true}
        confirmButtonLabel={"OK"}
        onConfirm={() => {
          navigate("/account");
        }}
      />
    );
  };

  const renderProfilePic = () => {
    let imageURI = undefined;

    if (_user.user_picture) {
      imageURI = _user.user_picture;
    }

    return (
      <Row>
        <Col
          className="d-flex justify-content-center align-content-center"
          xs={12}
          lg={12}
        >
          <UserImage
            user={user}
            uuid={_user.uuid}
            name={`${_user?.field_first_name} ${_user?.field_last_name}`}
            image={imageURI}
            owner="client"
            sub_variant="user-image"
            // userBrand={"rhg"}
            clientColor={"adminPrimary.main"}
            editable={userProfilePictureEnabled}
            onUploadSuccess={() => {
              getAccount();
            }}
          />
        </Col>
      </Row>
    );
  };

  const renderUserGreeting = () => {
    if (_user.field_first_name) {
      return (
        <Row className={"greeting"}>
          <Col
            className="d-flex justify-content-center align-content-center"
            xs={12}
            lg={12}
          >
            <Typography
              variant="h3"
              owner="admin"
              color="adminText.main"
              className="mb-2"
            >
              Hi, {_user.field_first_name}
            </Typography>
          </Col>
        </Row>
      );
    }
  };

  const renderUsername = () => {
    if (_user.name) {
      return (
        <Row className={"username d-flex justify-content-center my-1"}>
          <Col
            className="d-flex justify-content-center align-content-center pe-0"
            xs={"auto"}
          >
            <Typography
              owner="admin"
              variant="body1"
              color="adminText.main"
              weight="light"
              lh="wide"
            >
              Username:
            </Typography>
          </Col>
          <Col xs={"auto"} className="ps-1">
            <Typography
              owner="admin"
              variant="body1"
              color="adminText.main"
              lh="wide"
            >
              {_user.name}
            </Typography>
          </Col>
        </Row>
      );
    }
  };

  const renderUserRoles = () => {
    if (_user.roles_target_id) {
      return (
        <Row className={"role d-flex justify-content-center my-1"}>
          <Col
            className="d-flex justify-content-center align-content-center pe-0"
            xs={"auto"}
          >
            <Typography
              owner="admin"
              variant="body1"
              color="adminText.main"
              weight="light"
              lh="wide"
            >
              Role:
            </Typography>
          </Col>
          <Col xs={"auto"} className="ps-1">
            <Typography
              owner="admin"
              variant="body1"
              color="adminText.main"
              lh="wide"
            >
              {_user.roles_labels}
            </Typography>
          </Col>
        </Row>
      );
    }
  };

  const renderAccountDetails = () => {
    return (
      <>
        {renderProfilePic()}
        {renderUserGreeting()}
        {renderUsername()}
        {renderUserRoles()}
      </>
    );
  };

  /**
   * @function render
   * @description Default render method
   */
  if (isLoading) {
    return <AccountSkeletonScreen />;
  } else {
    if (isError) {
      return <Error status={errorStatus} message={errorMessage} />;
    } else {
      return (
        <main
          ref={containerRef}
          className="edit-profile screen d-flex flex-column h-100 justify-content-between"
        >
          <Row>
            <Col xs={12} lg={6} className="mx-lg-auto">
              {renderAccountDetails()}
              {errorAlerts()}
              {saveAlerts()}

              {editProfileEnabled && (
                <>
                  <PageHeader pageName="Edit Profile" filters={false} />

                  {/* First name */}
                  <div className="form-group">
                    <Row className="mt-2">
                      <Col>
                        <Typography
                          owner="admin"
                          variant="form-group-label"
                          lh="x-wide"
                        >
                          First name
                        </Typography>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <input
                          type="text"
                          onChange={(event) => {
                            setFirst_name(event.target.value);
                          }}
                          placeholder={"Add your first name..."}
                          value={first_name}
                          className="form-control"
                        />
                      </Col>
                    </Row>
                  </div>

                  {/* Last name */}
                  <div className="form-group">
                    <Row className="mt-2">
                      <Col>
                        <Typography
                          owner="admin"
                          variant="form-group-label"
                          lh="x-wide"
                        >
                          Last name
                        </Typography>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <input
                          type="text"
                          onChange={(event) => {
                            setLast_name(event.target.value);
                          }}
                          // placeholder={
                          //   user.field_last_name.length > 0
                          //     ? user.field_last_name
                          //     : "Add your last name..."
                          // }
                          placeholder={"Add your last name..."}
                          value={last_name}
                          className="form-control"
                        />
                      </Col>
                    </Row>
                  </div>

                  {/* Job title */}
                  <div className="form-group">
                    <Row className="mt-2">
                      <Col>
                        <Typography
                          owner="admin"
                          variant="form-group-label"
                          lh="x-wide"
                        >
                          Job title
                        </Typography>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <input
                          type="text"
                          onChange={(event) => {
                            setField_job_title(event.target.value);
                          }}
                          // placeholder={
                          //   user.field_last_name.length > 0
                          //     ? user.field_last_name
                          //     : "Add your last name..."
                          // }
                          placeholder={"Add job title..."}
                          value={field_job_title}
                          className="form-control"
                        />
                      </Col>
                    </Row>
                  </div>

                  {/* Phone number */}
                  <div className="form-group">
                    <Row className="mt-2">
                      <Col>
                        <Typography
                          owner="admin"
                          variant="form-group-label"
                          lh="x-wide"
                        >
                          Phone number
                        </Typography>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <input
                          // type="text"
                          // onChange={(phone_number) => {
                          //   setState({
                          //     phone_number: phone_number,
                          //   });
                          // }}
                          // placeholder={
                          //   user.phone_number.length > 0
                          //     ? user.phone_number
                          //     : "Add a phone number..."
                          // }
                          type="tel"
                          onChange={(event) => {
                            setPhone_number(event.target.value);
                          }}
                          placeholder={"Add your phone number..."}
                          value={phone_number}
                          className="form-control"
                        />
                      </Col>
                    </Row>
                  </div>

                
                  {/* Web address (URL) */}
                  <div className="form-group">
                    <Row className="mt-2">
                      <Col>
                        <Typography
                          owner="admin"
                          variant="form-group-label"
                          lh="x-wide"
                        >
                          Web address (URL)
                        </Typography>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <input
                          type="url"
                          onChange={(event) => {
                            setField_url(event.target.value);
                          }}
                          placeholder={"Add your web address..."}
                          value={field_url}
                          className="form-control"
                        />
                      </Col>
                    </Row>
                  </div>

                  {/* Physical address */}
                  <div className="form-group">
                    <Row className="mt-2">
                      <Col>
                        <Typography
                          owner="admin"
                          variant="form-group-label"
                          lh="x-wide"
                        >
                          Physical address
                        </Typography>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <input
                          type="url"
                          onChange={(event) => {
                            setField_address(event.target.value);
                          }}
                          placeholder={"Add your physical address..."}
                          value={field_address}
                          className="form-control"
                        />
                      </Col>
                    </Row>
                  </div>

                  {presenterTaxonomies && (
                    <div className="form-group">
                      <Row className="mt-2">
                        <Col>
                          <Typography
                            owner="admin"
                            variant="form-group-label"
                            lh="wide"
                          >
                            Email signature style
                          </Typography>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <CategorySelector
                            label="Email signature style"
                            variant="outlined"
                            size="small"
                            selectedCategory={{
                              value: field_email_template,
                            }}
                            handleCategorySelection={(id) => {
                              setField_email_template(id);
                            }}
                            categories={
                              category_email_template
                                ? category_email_template
                                : [{ value: 0, label: "" }]
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                  )}

                  {presenterTaxonomies && (
                    <Accordion className="ca-accordion edit-profile">
                      <AccordionSummary
                        className="ca-accordion-summary"
                        expandIcon={<KeyboardArrowRight />}
                      >
                        <Col xs={12} className="d-flex align-items-center">
                          Subscription information
                          <Divider className="mt-1 ms-2 flex-grow-1" />
                        </Col>
                      </AccordionSummary>
                      <AccordionDetails
                        className="ca-accordion-details"
                        sx={{
                          marginBottom: "10px",
                          paddingRight: "10%",
                          paddingLeft: "10%",
                        }}
                      >
                        <div className="form-group">
                          <Row className="mt-2">
                            <Col xs={4}>
                              <Typography
                                owner="admin"
                                variant="form-group-label"
                                lh="x-wide"
                              >
                                Subscriber area:
                              </Typography>
                            </Col>
                            <Col xs={8}>
                              <Typography
                                owner="admin"
                                variant="body2"
                                color="adminText.main"
                                lh="x-wide"
                                weight="light"
                              >
                                {field_region ? field_region : "None"}
                              </Typography>
                            </Col>
                          </Row>
                        </div>

                        {/* SITA */}
                        {sitaEnabled && (
                          <div className="form-group">
                            <Row className="mt-2">
                              <Col xs={4}>
                                <label>SITA code :</label>
                              </Col>
                              <Col xs={8}>
                                <Typography
                                  owner="admin"
                                  variant="body2"
                                  color="adminText.main"
                                  lh="x-wide"
                                  weight="light"
                                >
                                  {field_sita
                                    ? field_sita?.label
                                    : "None"}
                                </Typography>
                              </Col>
                            </Row>
                          </div>
                        )}

                        {referenceEnabled && (
                          <div className="form-group">
                            <Row className="mt-2">
                              <Col xs={4}>
                                <label>Reference:</label>
                              </Col>
                              <Col xs={8}>
                                <Typography
                                  owner="admin"
                                  variant="body2"
                                  color="adminText.main"
                                  lh="x-wide"
                                  weight="light"
                                >
                                  {field_reference
                                    ? field_reference?.label
                                    : "None"}
                                </Typography>
                              </Col>
                            </Row>
                          </div>
                        )}

                        {/* Cost Centre */}
                        <div className="form-group">
                          <Row className="mt-2">
                            <Col xs={4}>
                              <Typography
                                owner="admin"
                                variant="form-group-label"
                                lh="x-wide"
                              >
                                Cost centre :
                              </Typography>
                            </Col>
                            <Col xs={8}>
                              <Typography
                                owner="admin"
                                variant="body2"
                                color="adminText.main"
                                lh="x-wide"
                                weight="light"
                              >
                                {field_cost_centre
                                  ? field_cost_centre
                                  : "None"}
                              </Typography>
                            </Col>
                          </Row>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  )}

                  {/* {pushNotificationsEnabled && (
                    <NotificationsSetting
                      user={_user}
                    />
                  )} */}

                  <div
                    className={`form-group ${
                      !presenterTaxonomies ? "mt-3" : ""
                    }`}
                  >
                    <Row className="align-items-center justify-content-between">
                      <Col>
                        <Link to={"/"}>
                          <Button
                            variant="outlined"
                            sx={{
                              textTransform: "none",
                            }}
                          >
                            <Typography
                              owner="admin"
                              variant="subtitle1"
                              weight="medium"
                              lh="x-wide"
                            >
                              Cancel
                            </Typography>
                          </Button>
                        </Link>
                      </Col>
                      <Col xs={"auto"}>
                        {isSubmitting ? (
                          <CircularProgress />
                        ) : (
                          <Button
                            className="submit-btn"
                            onClick={updateUser}
                            sx={{
                              textTransform: "none",
                              backgroundColor: "secondary.main",
                              color: "solid.light",
                              "&:hover": {
                                backgroundColor: "secondary.dark",
                              },
                            }}
                          >
                            <Typography
                              owner="admin"
                              variant="subtitle1"
                              weight="medium"
                              lh="x-wide"
                            >
                              Save profile
                            </Typography>
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </div>
                </>
              )}
            </Col>
          </Row>

          <Creator />

          <div style={{ display: "none" }}>
            <a
              id="back-to-account"
              href="/"
              ref={(link) => (backToAccount.current = link)}
            >
              Account
            </a>
          </div>
        </main>
      );
    }
  }
}
